// extracted by mini-css-extract-plugin
export default {"ticketIcon":"TicketIcon_ticketIcon__5zYqN"};